import React from 'react';
import { Container, Card, CardGroup, Modal, Button } from 'react-bootstrap';
import './styles/Conocenos.css';
import multi from '../archivos/multiculturales.svg';
import inclu from '../archivos/inclusivos.svg';
import diver from '../archivos/diversos.svg';
import remo from '../archivos/remotos.svg';
import forma4 from '../archivos/forma4.png';
import vector45 from '../archivos/vector4-5.png';
import { withTranslation } from 'react-i18next';
class Conocenos extends React.Component {
	constructor() {
		super();
		this.state = {
			info: [],
		};
	}
	state = {
		abierto: false,
	};

	abrirModal = () => {
		this.setState({ abierto: !this.state.abierto });
	};

	render() {
		const { t, i18n } = this.props;

		return (
			<Container id='Home' className='containConocenos'>
				<section className='sectionStyle'>
					<h1 className='h1w'>{t('Conocenos.1')}</h1>

					<a
						href='https://meetings.hubspot.com/alejandra-ripa-alberdi'
						rel='noreferrer'
						target='_blank'
						style={{ display: 'flex', justifyContent: 'center' }}
					>
						<div className='linkMeet'>{t('Meeting')}</div>
					</a>
				</section>
				<section
					id='Conocenos'
					style={{
						backgroundColor: '#fff',
						width: '100%',
						height: 'auto',
						maxWidth: '100%',
						paddingBottom: '2%',
					}}
				>
					<h1 className='h1tittle'>{t('Conocenos.2')}</h1>

					<p className='par'>
						{t('Conocenos.par1.1')}
						<span style={{ fontWeight: 'bold' }}>{t('Conocenos.par1.2')}</span>
						{t('Conocenos.par1.3')}
						<span style={{ fontWeight: 'bold' }}>{t('Conocenos.par1.4')}</span>
					</p>
					<p className='par'>{t('Conocenos.par2')}</p>
					<p className='par'>
						<span style={{ fontWeight: 'bold' }}>{t('Conocenos.par3.1')} </span> <br></br>
						{t('Conocenos.par3.2')} "{t('Conocenos.par3.3')}" {t('Conocenos.par3.4')} "{t('Conocenos.par3.5')}
						"
					</p>
				</section>
				<section className='sboton'>
					<button className='boton' onClick={this.abrirModal}>
						{t('Conocenos.boton')}
					</button>
				</section>
				<section className=''>
					<img className='absol' src={forma4} width='100%' height='auto' alt='Símbolo de Jedify' />
				</section>
				<section className='como'>
					<h1 className='title'>{t('Conocenos.title')}</h1>
					<section className='cSection'>
						<CardGroup>
							<Card className='cards'>
								<Card.Img variant='top' className='cImg' src={multi} />
								<Card.Body>
									<Card.Title style={{ fontWeight: 'bold' }}>{t('Conocenos.card1')}</Card.Title>
								</Card.Body>
							</Card>

							<Card className='cards'>
								<Card.Img variant='top' className='cImg' src={inclu} />
								<Card.Body>
									<Card.Title style={{ fontWeight: 'bold' }}>{t('Conocenos.card2')}</Card.Title>
								</Card.Body>
							</Card>

							<Card className='cards'>
								<Card.Img variant='top' className='cImg' src={diver} />
								<Card.Body>
									<Card.Title style={{ fontWeight: 'bold' }}>{t('Conocenos.card3')}</Card.Title>
								</Card.Body>
							</Card>

							<Card className='cards'>
								<Card.Img variant='top' className='cImg' src={remo} />
								<Card.Body>
									<Card.Title style={{ fontWeight: 'bold' }}>{t('Conocenos.card4')}</Card.Title>
								</Card.Body>
							</Card>
						</CardGroup>
					</section>
					<section className='sectionAbsol'>
						<h1 className='h1tittle'>
							{t('Conocenos.h1tittle1')}
							<br></br>
							{t('Conocenos.h1tittle2')}
						</h1>
						<p className='par'>{t('Conocenos.p1')}</p>
						<p className='par'>{t('Conocenos.p2')}</p>
						<p className='par pb'>{t('Conocenos.p3')}</p>
						<section className='absol2'>
							<img src={vector45} width='100%' height='auto' alt='Símbolo de Jedify' />
						</section>
						<section className='apasiona'>
							<h1 className='apaTittle'>{t('Conocenos.apatitle')}</h1>
						</section>
					</section>
				</section>
				<Modal
					className='modaljedi'
					show={this.state.abierto}
					size='xl'
					aria-labelledby='contained-modal-title-vcenter'
					centered
				>
					<Modal.Header className='modal-header'>
						<Button className='close' onClick={this.abrirModal}>
							+
						</Button>
					</Modal.Header>
					<Modal.Body className='modal-body'>
						<p className='par2'>{t('Modal.p1')}</p>
						<p className='par2'>{t('Modal.p2')}</p>
						<p className='par2'>{t('Modal.p3')}</p>

						<p className='par2 footerModal'>{t('Modal.h3')}</p>
					</Modal.Body>
					{/* <Modal.Footer>
          </Modal.Footer> */}
				</Modal>
			</Container>
		);
	}
}
export default withTranslation()(Conocenos);
